<template>
  <section class="pageContents">
    <div class="pageContents-text container">
      <Devices />
    </div>
  </section>
</template>

<script>
import { Options, Vue } from 'vue-class-component';
import Devices from '@/components/devices.vue';

@Options({
    name: 'DevicesView',
    components: {
        Devices,
    },
    props: {
      msg: String
    },
    emits: {
        //select: (myProperty: string) => typeof myProperty === 'string'
    },
  })
export default class DevicesView extends Vue {}
</script>
